import TwoColumnContent from '../../../components/TwoColumnContent/TwoColumnContent';
import LeftColumn from '../../../components/TwoColumnContent/LeftColumn/LeftColumn';
import TitleDescription from '../../../components/TitleDescription/TitleDescription';
import RightColumn from '../../../components/TwoColumnContent/RightColumn/RightColumn';
import { AdminSelect } from '@project/components';
import styles from '../InviteTeamMember.module.css';
import React, { useContext, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useFormContext } from 'react-hook-form';
import { RootContext } from '../../../hoc/RootContext/RootContext';

export const TeamMemberCompanySelector = props => {
  const intl = useIntl();
  const t = id => intl.formatMessage({ id });

  const { currentUser } = useContext(RootContext);
  const form = useFormContext();

  const companyOptions = useMemo(() => {
    if (currentUser && currentUser.companies.length > 1) {
      return currentUser.displayCompanies
        .map(company => ({ label: company.displayName || company.name, value: company.name }))
        .sort((a, b) => (a.label > b.label ? 1 : -1));
    } else {
      return [];
    }
  }, [currentUser]);

  return (
    <>
      {companyOptions.length > 0 && (
        <TwoColumnContent bottomBorder={true}>
          <LeftColumn>
            <TitleDescription
              title={t('InviteTeamMember.newMember.title')}
              description={intl.formatMessage(
                { id: 'InviteTeamMember.newMember.description' },
                { displayCompany: form.watch('displayCompany') }
              )}
            />
          </LeftColumn>
          <RightColumn>
            <AdminSelect
              id="company"
              propStyles={styles.adminSelect}
              options={companyOptions}
              value={{ label: form.watch('displayCompany'), value: form.watch('company') }}
              onChange={c => {
                form.setValue('company', c.value);
                form.setValue('displayCompany', c.label);
              }}
              isLoading={false}
            />
          </RightColumn>
        </TwoColumnContent>
      )}
    </>
  );
};
